import React from 'react'
import Headline from '../atoms/Headline'
import Richtext from '../atoms/Richtext'
import Figure from '../atoms/Figure'
import SbEditable from 'storyblok-react'

const TextWithPortraitImageBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section
        className={`content-block-two-col text-with-image-block text-with-image-block-text-valing-${
          block.text_vertical_align
        } text-with-image-block-image-size-${block.image_size} ${
          block.space_top ? block.space_top : ''
        } ${block.space_bottom ? block.space_bottom : ''} ${
          block.ratio ? block.ratio : ''
        }`}
      >
        <div className="content-block-two-col-body">
          <div className="row">
            <div className="content-col-2 content-col-text">
              <Headline
                kicker={block.kicker}
                headline={block.headline}
                subheadline={block.subheadline}
                headline_level={block.headline_level}
              />
              <Richtext text={block.text} />
            </div>
            <div className="content-col-2 content-col-image">
              <Figure
                image={block.image}
                image_link={block.image_link}
                align_image={block.align_image}
                image_size={block.image_size}
                caption={block.caption}
              />
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default TextWithPortraitImageBlock
